import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BRYCEN_CLICKED,
  JILLIAN_CLICKED,
  WEDDING_DATE_CLICKED,
  COUNTDOWN_CHANGED,
} from '../actions/actionTypes';
import './Title.css';
import { CEREMONY_DATE, PRECEPTION_DATE } from '../constants';
import moment from 'moment';

function importAll(r) {
  const images = {};
  r.keys().forEach((item, index) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}

const images = importAll(require.context('../assets', false, /\.gif$/));

const mapStateToProps = state => ({
  jillianFace: state.title.jillianFace || 0,
  brycenFace: state.title.brycenFace || 0,
  showFullDate: state.title.showFullDate || false,
  invitee: state.invitee,
  ca: state.invitee.events.ca,
  ny: state.invitee.events.ny,
  countdown: state.title.countdown || '',
});

const mapDispatchToProps = dispatch => ({
  brycenClicked: payload =>
    dispatch({ type: BRYCEN_CLICKED, brycenFace: payload }),
  jillianClicked: payload =>
    dispatch({ type: JILLIAN_CLICKED, jillianFace: payload }),
  dateClicked: payload =>
    dispatch({ type: WEDDING_DATE_CLICKED, showFullDate: payload }),
  countdownChanged: payload =>
    dispatch({ type: COUNTDOWN_CHANGED, countdown: payload }),
});

class Title extends Component {
  numberOfJillianPhotos = Object.keys(images).reduce(
    (acc, cur) => (cur.includes('jill') ? acc + 1 : acc),
    0
  );
  numberOfBrycenPhotos = Object.keys(images).reduce(
    (acc, cur) => (cur.includes('bry') ? acc + 1 : acc),
    0
  );

  faceClicked(e) {
    if (e.target.id.includes('brycen')) {
      this.props.brycenClicked(this.props.brycenFace);
    } else {
      this.props.jillianClicked(this.props.jillianFace);
    }
  }

  dateClicked(e) {
    this.props.dateClicked(this.props.showFullDate);
  }

  componentWillMount() {
    this.sectionId = `section-${this.props.section}`;
    this.countdownTime();
  }

  countdownTime() {
    setInterval(() => {
      const diffTime = moment(CEREMONY_DATE).diff(moment());
      const duration = moment.duration(diffTime);
      const days = `${duration.days()}`.padStart(2, '0');
      const hours = `${duration.hours()}`.padStart(2, '0');
      const minutes = `${duration.minutes()}`.padStart(2, '0');
      const countdown = `${days} Days ${hours} Hours ${minutes} Minutes`;
      this.props.countdownChanged(countdown);
    }, 5000);
  }

  render() {
    this.brycenPhotoNumber =
      (this.props.brycenFace % this.numberOfBrycenPhotos) + 1;
    this.jillPhotoNumber =
      (this.props.jillianFace % this.numberOfJillianPhotos) + 1;

    const eventDate =
      this.props.ca && !this.props.ny ? PRECEPTION_DATE : CEREMONY_DATE;

    const DateCA = (
      <div className="subtitle" onClick={this.dateClicked.bind(this)}>
        <h2>{eventDate.format('DD.MM.YY')}</h2>
      </div>
    );
    const DateUS = (
      <div className="subtitle" onClick={this.dateClicked.bind(this)}>
        <h2>{eventDate.format('MM.DD.YY')}</h2>
      </div>
    );
    const DateFull = (
      <div
        className="subtitle added-side-padding"
        onClick={this.dateClicked.bind(this)}
      >
        <h2>{eventDate.format('MMMM Do, YYYY')}</h2>
      </div>
    );
    let numEvents = Object.keys(this.props.invitee.events).length;
    let WeddingDate = null;
    if (this.props.invitee.authorized === true && numEvents > 0) {
      if (this.props.showFullDate === true) WeddingDate = DateFull;
      else
        WeddingDate = this.props.invitee.region.includes('us')
          ? DateUS
          : DateCA;
    }
    const fullSize = (
      <div id={this.sectionId} className="title title-full">
        <div>
          <img
            id="jill-face"
            src={images[`jill${this.jillPhotoNumber}.gif`]}
            alt="Jill"
            onClick={this.faceClicked.bind(this)}
          />
          <div>
            <h1>Jillian</h1>
            <h1 className="stupid-plus">+</h1>
            <h1>Brycen</h1>
            {WeddingDate}
            {this.props.invitee.authorized && this.props.ny && (
              <div className="countdown">{this.props.countdown}</div>
            )}
          </div>
          <img
            id="brycen-face"
            src={images[`brycen${this.brycenPhotoNumber}.gif`]}
            alt="Brycen"
            onClick={this.faceClicked.bind(this)}
          />
        </div>
      </div>
    );

    const smallSize = (
      <div id={this.sectionId} className="title title-small">
        <div className="flex-column">
          <div>
            <h1>Jillian</h1>
            <h1>+</h1>
            <h1>Brycen</h1>
            {WeddingDate}
            {this.props.invitee.authorized && this.props.ny && (
              <div className="countdown">{this.props.countdown}</div>
            )}
          </div>
          <div className="flex-row">
            <img
              id="jill-face"
              src={images[`jill${this.jillPhotoNumber}.gif`]}
              alt="Jill"
              onClick={this.faceClicked.bind(this)}
            />
            <img
              id="brycen-face"
              src={images[`brycen${this.brycenPhotoNumber}.gif`]}
              alt="Brycen"
              onClick={this.faceClicked.bind(this)}
            />
          </div>
        </div>
      </div>
    );

    // return fullSize;
    return (
      <div>
        {smallSize}
        {fullSize}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Title);



// WEBPACK FOOTER //
// ./src/components/Title.js